import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import SearchOffRoundedIcon from "@mui/icons-material/SearchOffRounded";
import { useNavigate } from "react-router-dom";

const NotFoundPage = ({
  type = "page",
  name = "",
  icon: Icon = SearchOffRoundedIcon,
}) => {
  const navigate = useNavigate();

  const title = "Page Not Found";
  const description =
    "The page you are looking for does not exist or has been moved.";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        background: "#071525",
        color: "#fff",
        py: 8,
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            textAlign: "center",
            px: { xs: 2, sm: 4 },
          }}
        >
          <Box
            sx={{
              width: 82,
              height: 82,
              mx: "auto",
              mb: 3,
              borderRadius: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(255,255,255,0.06)",
              border: "1px solid rgba(255,255,255,0.12)",
              boxShadow: "0 20px 50px rgba(0,0,0,0.25)",
            }}
          >
            <Icon sx={{ fontSize: 42, color: "#00c853" }} />
          </Box>

          <Typography
            sx={{
              fontSize: { xs: 72, sm: 92 },
              fontWeight: 800,
              lineHeight: 1,
              letterSpacing: "-5px",
              color: "rgba(255,255,255,0.12)",
            }}
          >
            404
          </Typography>

          <Typography
            variant="h4"
            sx={{
              mt: 2,
              fontWeight: 700,
              fontSize: { xs: 28, sm: 36 },
            }}
          >
            {title}
          </Typography>

          <Typography
            sx={{
              mt: 2,
              color: "rgba(255,255,255,0.68)",
              fontSize: 16,
              lineHeight: 1.7,
            }}
          >
            {description}
          </Typography>

          <Button
            onClick={() => navigate("/")}
            sx={{
              mt: 4,
              px: 4,
              py: 1.3,
              borderRadius: "999px",
              textTransform: "none",
              fontWeight: 700,
              background: "#00c853",
              color: "#071525",
              "&:hover": {
                background: "#00e676",
              },
            }}
          >
            Back to Home
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default NotFoundPage;
